import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-order-sheet',
  templateUrl: './order-sheet.component.html',
  styleUrls: ['./order-sheet.component.css']
})
export class OrderSheetComponent {

  public name: string = 'Order sheet'
  loadingPercent = 0;
  isStart = false;
  // res: Observable<null | string> = of(null);
  intervalId = {} as any;
  constructor() { }

  ngOnInit() {
    this.startLoading()
  }

  startLoading() {
    this.isStart = true;
    this.intervalId = setInterval(() => {
      if (this.loadingPercent < 100) {
        this.loadingPercent += 1;
      }
    }, 100);
  }
  progressInLoading() {
    if (this.loadingPercent === 100) {
      clearInterval(this.intervalId);
      // this.res = of("Item Loaded");
    }
    console.log('Loading: ' + this.loadingPercent + '% completed.');
  }

}
